<section class="w-100 float-left teams_section">
    <div class="container">
        <div class="main_title d-flex justify-content-center">
            <h1 class="line"><span>Our</span> Team </h1>
        </div>
        <h2 class="sub_title text-center w-100 float-left">People who guide us and lead InheritX Solutions toward
            excellence with their unique vision</h2>
        <div class="teams_box w-100 float-left">
            <div class="row">
                <div *ngFor="let team of teams" class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-6">
                    <div class="w-100 float-left team_single_box">
                        <div class="w-100 float-left team_single_box_img">
                            <img [src]="team.feature_image" class="w-100" alt="our team">
                        </div>
                        <div class="w-100 float-left team_name">
                            {{team.title}}
                            <span>{{team.designation}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>